import React from "react";

function NotFound() {
  return (
    <>
      <div className="flex justify-center items-center min-h-screen bg-slate-200">
        <h1 className="text-2xl  border-2 border-red-700 p-10 rounded-lg">
          404 Error page not found
        </h1>
      </div>
    </>
  );
}

export default NotFound;
